module.exports = {"430503001":"中心路街道","430503002":"红旗路街道","430503003":"城北路街道","430503004":"城西街道","430503005":"翠园街道","430503006":"百春园街道","430503007":"城南街道","430503008":"火车南站街道","430503009":"学院路街道","430503010":"雨溪街道","430503011":"檀江街道","430503101":"罗士镇","430503202":"蔡锷乡","430503203":"板桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430503.json
// module id = 1688
// module chunks = 0